import _ from "lodash"

export const find = (list, f) => list.filter(f)[0]

export const assert = (condition, msg) => {
  if (!condition) throw new Error(`[Front-End] ${msg}`)
}

export const deepCopy = (obj, cache = []) => {
  if (obj === null || typeof obj !== "object") {
    return obj
  }

  const hit = find(cache, c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}

  cache.push({
    original: obj,
    copy
  })

  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

export const validate = ({
  message,
  target,
  regex,
  exception = () => false
}) => {
  const resultMessage = `${message} 을(를) 설정해주세요.`

  const except = typeof exception === "function" ? exception() : exception
  if (except) {
    return { message: resultMessage, flag: false }
  }

  if (regex === undefined)
    return { message: resultMessage, flag: _.isEmpty(target) }

  const result = new RegExp(regex)
  return { message: resultMessage, flag: !result.test(target) }
}

export const multipleValidate = validateList => {
  let result = { message: "", flag: false }

  validateList.some(valid => {
    if (valid.flag) result = valid

    return valid.flag
  })

  return result
}

export const regex = (min = 0, max = 0) => ({
  ko: `^[ㄱ-ㅎㅏ-ㅣ가-힣//s\\s]{${min},${max}}$`,
  ko_num: `^[ㄱ-ㅎㅏ-ㅣ가-힣0-9//s\\s\\/\\~\\*\\&\\$\\#\\@\\!\\-\\=\\+\\(\\)\\_\\>\\<\\?\\,\\.\\'\\"\\:\\;\\[\\]\\{\\}\\^]{${min},${max}}$`,
  ko_en_num: `^[ㄱ-ㅎㅏ-ㅣ가-힣a-zA-Z0-9//s\\s\\/\\~\\*\\&\\$\\#\\@\\!\\-\\=\\+\\(\\)\\_\\>\\<\\?\\,\\.\\'\\"\\:\\;\\[\\]\\{\\}\\^]{${min},${max}}$`,
  en: `^[a-zA-Z//s\\s]{${min},${max}}$`,
  en_num: `^[a-zA-Z0-9|é//s\\s\\/\\~\\*\\&\\$\\#\\@\\!\\-\\=\\+\\(\\)\\_\\>\\<\\?\\,\\.\\'\\"\\:\\;\\[\\]\\{\\}\\^]{${min},${max}}$`,
  num: `^[0-9//s]{${min},${max}}$`,
  num_space: `^[0-9//s\\s]{${min},${max}}$`,
  num_dot: `^[0-9//s\\.]{${min},${max}}$`,
  num_dot_minus: `^[0-9//s\\.\\-]{${min},${max}}$`,
  url:
    "https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|www\\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\\.[^\\s]{2,}|https?:\\/\\/(?:www\\.|(?!www))[a-zA-Z0-9]+\\.[^\\s]{2,}|www\\.[a-zA-Z0-9]+\\.[^\\s]{2,}"
})

export function parseJwt(token) {
  const b64DecodeUnicode = str =>
    decodeURIComponent(
      Array.prototype.map
        .call(
          atob(str),
          c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`
        )
        .join("")
    )

  const base64Url = token.split(".")[1]
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  return JSON.parse(b64DecodeUnicode(base64))
}



// WEBPACK FOOTER //
// ./src/utils/utils.js